import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'app-font-size-input',
	templateUrl: './font-size-input.component.html',
	styleUrls: ['./font-size-input.component.scss']
})
export class FontSizeInputComponent implements OnInit {

	@Input() fontSize: string = '';
	@Output() fontSizeChange = new EventEmitter<string>();
	constructor() { }

	get value(): number {
		return Number(this.fontSize);
	}
	set value(size: number) {
		this.stringValue = '' + size;
	}
	get stringValue(): string {
		return '' + (this.fontSize as string);
	}
	set stringValue(size: string) {
		this.fontSize = size;
		this.fontSizeChange.emit(this.fontSize);
	}

	HandleChange() {
		this.value = this.value;
	}


	ngOnInit() {
	}

}
